module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"heading":"Edit Post","cancelLink":"Dismiss Draft"},"de":{"heading":"Beitrag Bearbeiten","cancelLink":"Änderung Verwerfen"}}')
  delete Component.options._Ctor
}
